// Copyright 2022 Sorama B.V.
import { autoinject, Container, customElement } from "aurelia-framework";
import { Alert } from "controls/alert/Alert";

@customElement("alert-stack")
@autoinject
export class AlertStack {
    constructor(private container: Container) {}

    public alerts: Alert[] = [];
    public maxAlerts = 10;

    public pushError(message: string, autoCloseSeconds?: number) {
        if (this.alerts.length === this.maxAlerts) {
            this.alerts.shift();
        }

        const alert = this.container.get(Alert);
        alert.alertText = message;
        alert.alertType = "alert-error-small";
        alert.closeAction = () => {
            this.remove(alert);
        };
        this.alerts.push(alert);

        if (autoCloseSeconds) {
            setTimeout(() => this.remove(alert), autoCloseSeconds * 1000);
        }
    }

    private remove(alert: Alert) {
        this.alerts.splice(
            this.alerts.findIndex((x) => x === alert),
            1
        );
    }

    public clear() {
        this.alerts = [];
    }
}
